module.exports = __webpack_public_path__ + "static/media/rise-and-code.6406a8d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rise-and-code.jpg
// module id = 428
// module chunks = 0